// src/pages/user/maintainance/subscreens/mechanicsingledetail/MechanicDetail.jsx

import React, { useContext, useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import "../../../../assets/css/user/maintainance/subscreens/mechanicsingledetail/MechanicDetail.css";
import BookAppointmentModal from "../../../../subscreens/users/Maintain/bookappointment/BookAppointment.js";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../../context/AppContext.js";

const MechanicDetail = () => {
  const { id } = useParams();
  const { baseUrl, baseUrlForFile, loggedInCustomer, loggedInRental ,authToken } =
    useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();

  const [mechanic, setMechanic] = useState(null);
  const [showBookingModal, setShowBookingModal] = useState(false);

  // ── isLoggedIn — context ki base par (localStorage manually parse
  //    karne ki zaroorat nahi, AppContext se hi source of truth lein) ──
  const isUserLoggedIn = Boolean(loggedInCustomer || loggedInRental);

  // ── fetchSingleMechanic ──────────────────────────────────────
  const fetchSingleMechanic = () => {
    axios
      .get(`${baseUrl}/customer/detailmehanic/fetchSingleMechanic/${id}`)
      .then((response) => {
        if (response.data.success === true) {
          setMechanic(response.data.mechanic);
        }
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchSingleMechanic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // ── Booking modal — login se wapas aane ke baad pending booking
  //    open karna. Ye check context (isUserLoggedIn) par depend karta
  //    hai — jab tak customer/rental actually logged in nahi, modal
  //    open nahi hoga, chahe pendingBooking flag localStorage mein
  //    kyun na ho. ──
  useEffect(() => {
    if (!isUserLoggedIn) return;

    const pendingBooking = JSON.parse(localStorage.getItem("pendingBooking"));
    if (
      pendingBooking &&
      pendingBooking.openModal &&
      Number(pendingBooking.mechanicId) === Number(id)
    ) {
      setShowBookingModal(true);
      localStorage.removeItem("pendingBooking");
      localStorage.removeItem("redirectAfterLogin");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, isUserLoggedIn]);

  // ── Booking modal — via location.state ──────────────────────
  useEffect(() => {
    if (location.state?.openBookingModal) {
      setShowBookingModal(true);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  // ── Talk Now — login ke baad wapas aana ─────────────────────
  useEffect(() => {
    const shouldOpenTalk = localStorage.getItem("openTalkNowAfterLogin");

    if (shouldOpenTalk === "true" && isUserLoggedIn && mechanic) {
      localStorage.removeItem("openTalkNowAfterLogin");
      handleTalkNow();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mechanic, isUserLoggedIn]);

  // ── Image URL ────────────────────────────────────────────────
  const getImageUrl = (img) => {
    if (!img) return "/default.png";
    return `${baseUrlForFile}/${img}`;
  };

  // ── Loading state ────────────────────────────────────────────
  if (!mechanic) {
    return (
      <div className="detail-page">
        <div className="container">
          <div className="not-found">
            <h2>Loading...</h2>
          </div>
        </div>
      </div>
    );
  }

  // ── Dynamic booking-capacity values ──────────────────────────
  // Backend se ye 3 fields aani chahiye: booking_limit, active_bookings_count, booking_fee
  const bookingLimit = Number(mechanic.booking_limit ?? 5);
  const activeBookings = Number(mechanic.active_bookings_count ?? 0);
  const isFullyBooked = activeBookings >= bookingLimit;
  const bookingFee = mechanic.booking_fee ?? mechanic.rate ?? 0;

  // ── handleContactNow (Booking) ───────────────────────────────
  const handleContactNow = () => {
    if (isFullyBooked) {
      Swal.fire({
        icon: "info",
        title: "Mechanic Not Available",
        text: "Ye mechanic is waqt apni booking limit tak pohanch chuka hai. Baraye meherbani next availability ka intezar karein.",
        confirmButtonColor: "#FDB714",
      });
      return;
    }

    // ── Login check — context (isUserLoggedIn) se ──────────────
    if (!isUserLoggedIn) {
      localStorage.setItem(
        "pendingBooking",
        JSON.stringify({
          mechanicId: id,
          mechanicRoute: window.location.pathname,
          openModal: true,
        }),
      );
      localStorage.setItem("redirectAfterLogin", window.location.pathname);

      // Rental-admin panel se aaya hai to usi ke login page par bhejein,
      // warna normal customer/auth page par
      if (window.location.pathname.startsWith("/rental-admin")) {
        navigate("/rental-admin/login");
      } else {
        navigate("/auth");
      }
      return;
    }

    setShowBookingModal(true);
  };

  // ── handleTalkNow ────────────────────────────────────────────
 const handleTalkNow = async () => {
  const customer = loggedInCustomer;
  const rental = loggedInRental;
  try {
    if (!customer && !rental) {
      localStorage.setItem("redirectAfterLogin", window.location.pathname);
      localStorage.setItem("openTalkNowAfterLogin", "true");

      if (window.location.pathname.startsWith("/rental-admin")) {
        navigate("/rental-admin/login");
      } else {
        navigate("/auth");
      }
      return;
    }

    // ── Rental Admin path ──
    if (rental) {
      const rentalToken = localStorage.getItem("authToken"); // 👈 sahi key confirm karo

      const response = await axios.post(
        `${baseUrl}/rentaladmin/conversations/checkMechanicConversation`,
        { srmechanicadmin_id: mechanic.id, srrentaladmin_id: rental.id },
        { headers: { Authorization: `Bearer ${rentalToken}` } }   // 👈 ye missing tha
      );

      if (response.data.exists) {
        navigate("/rental-admin/messages", {
          state: { openConversationId: response.data.conversation.id },
        });
        return;
      }

      navigate(`/rental-admin/mechanic-chat/${mechanic.id}`, {
        state: {
          mechanic: {
            id: mechanic.id,
            fullname: mechanic.fullname,
            specialization: mechanic.specialization,
            rate: mechanic.rate,
            image: mechanic.image,
            availability: mechanic.availability,
            location: mechanic.location,
            srmechanicadmin_id: mechanic.id,
          },
        },
      });
      return;
    }

    // ── Customer path ──
    const customerToken = localStorage.getItem("authToken"); // 👈 sahi key confirm karo

    const response = await axios.post(
      `${baseUrl}/customer/conversation/checkCMechaniconversation`,
      { srmechanicadmin_id: mechanic.id, srcustomer_id: customer.id },
      { headers: { Authorization: `Bearer ${customerToken}` } }   // 👈 ye bhi missing tha
    );

    if (response.data.exists) {
      navigate("/user/messages", {
        state: { openConversationId: response.data.conversation.id },
      });
      return;
    }

    navigate(`/mechanic-chat/${mechanic.id}`, {
      state: {
        mechanic: {
          id: mechanic.id,
          fullname: mechanic.fullname,
          specialization: mechanic.specialization,
          rate: mechanic.rate,
          image: mechanic.image,
          availability: mechanic.availability,
          location: mechanic.location,
          srmechanicadmin_id: mechanic.id,
        },
      },
    });
  } catch (error) {
    console.log("handleTalkNow error:", error);
  }
};

  // ── render ───────────────────────────────────────────────────
  return (
    <>
      <div className="detail-page">
        <div className="container">
          <div className="detail-card">
            {/* Left Side - Image */}
            <div className="detail-image-section">
              <img
                src={getImageUrl(mechanic.image)}
                alt={mechanic.fullname}
                className="detail-image"
              />
            </div>

            {/* Middle - Details */}
            <div className="detail-info-section">
              <div className="detail-header">
                <h1 className="detail-name">{mechanic.fullname}</h1>
                <p className="detail-specialization">
                  {mechanic.specialization}
                </p>
                <div className="detail-rating">
                  {[...Array(5)].map((_, index) => (
                    <span key={index} className="star">
                      {index < Math.round(mechanic.avg_rating || 0) ? "★" : "☆"}
                    </span>
                  ))}
                  <span className="rating-text">
                    ({mechanic.avg_rating || 0})
                  </span>
                </div>
              </div>

              <div className="detail-skills">
                <h3>Expertise</h3>
                <div className="skills-list">
                  {mechanic?.expertise?.split(",")?.map((skill, index) => (
                    <span key={index} className="skill-tag">
                      {skill.trim()}
                    </span>
                  ))}
                </div>
              </div>

              <div className="info-grid">
                <div className="info-item">
                  <span className="info-icon">📅</span>
                  <div className="info-content">
                    <p className="info-label">Experience</p>
                    <p className="info-value">{mechanic.yearsofexperience} Years</p>
                  </div>
                </div>
                <div className="info-item">
                  <span className="info-icon">📍</span>
                  <div className="info-content">
                    <p className="info-label">Location</p>
                    <p className="info-value">{mechanic.location}</p>
                  </div>
                </div>
                <div className="info-item fee-item">
                  <div className="info-content">
                    <p className="info-label">Booking Fee</p>
                    <p className="info-value">Rs. {mechanic.bookingfee} (Fixed Per Booking)</p>
                  </div>
                </div>
              </div>

              {/* Booking Limit Box */}
              <div className="booking-limit-box">
                <div className="booking-limit-left">
                  <span className="booking-limit-icon">👥</span>
                  <h4>Booking Limit</h4>
                </div>
                <span className="booking-limit-count">
                  {activeBookings}/{bookingLimit}
                </span>
              </div>

              <div className="detail-actions">
                <button className="book-now-btn" onClick={handleTalkNow}>
                  TALK NOW
                </button>
                {!isFullyBooked && (
                  <button className="contact-btn" onClick={handleContactNow}>
                    📅 REQUEST FOR BOOKING
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Book Appointment Modal */}
      {!isFullyBooked && (
        <BookAppointmentModal
          show={showBookingModal}
          onHide={() => {
            setShowBookingModal(false);
            fetchSingleMechanic(); // booking limit counts turant refresh ho jayein
          }}
          mechanic={mechanic}
        />
      )}
    </>
  );
};

export default MechanicDetail;